import ApiBase from './ApiBase';
import axios from 'axios';
import { stringify } from '../components/forked/stringify';

/**
 * EmailArchiveAttachment Api
 */
class EmailArchiveAttachmentApi extends ApiBase {
  /**
   * Download proofing file
   * @param {*} attachment
   */
  async downloadAttachmentFile({
    emailArchiveId,
    id: fileId,
    attachmentIdType
  }) {
    const payload = { emailArchiveId, fileId, attachmentIdType };
    const request = {
      url: `${this.API_URL}/emailarchive/attachment/download?${stringify(
        payload
      )}`,
      headers: this.getHeaders(),
      method: 'GET',
      responseType: 'blob'
    };

    const response = await axios.request(request);
    return response;
  }
}

export default new EmailArchiveAttachmentApi();
